import React, { useState, useMemo, useEffect } from 'react';
import ProductGrid from '../../components/store/ProductGrid';
import ProductFilter from '../../components/store/ProductFilter';
// import ShoppingCart from '../../components/store/ShoppingCart';
import CurrencyConverter from '../../components/store/CurrencyConverter';
import SearchBar from '../../components/store/SearchBar';
import '../../assets/css/pages/store.css';
import '../../assets/css/elements/currency-converter.css';
import '../../assets/css/elements/search-bar.css';
import prod from '../../assets/images/prod_img.png';
import { useCart } from '../../context/CartContext';
import { productsApi } from '../../network/apis/products';

const StorePage = () => {
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([{ id: 'all', name: 'All Products' }]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [currentCurrency, setCurrentCurrency] = useState({ code: 'NGN', symbol: '₦', rate: 1 });
    const [searchQuery, setSearchQuery] = useState('');
    const { addToCart } = useCart();

    // Fetch products and categories on component mount
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError(null);
            try {
                // Fetch products and categories in parallel
                const [productsRes, categoriesRes] = await Promise.all([
                    productsApi.getProducts(),
                    productsApi.getCategories()
                ]);
                
                // Handle products response
                const productsData = productsRes.results || productsRes.data || [];
                // Add fallback image for products without images
                console.log(productsRes)
                const processedProducts = productsData.map(product => ({
                    ...product,
                    image: product.image || prod
                }));
                setProducts(processedProducts);
                
                // Handle categories response
                const categoriesData = categoriesRes.results || categoriesRes.data || categoriesRes || [];
                const formattedCategories = [
                    { id: 'all', name: 'All Products' },
                    ...categoriesData.map(cat => ({
                        id: cat.id,
                        name: cat.name
                    }))
                ];
                setCategories(formattedCategories);
            } catch (err) {
                console.error('Error fetching store data:', err);
                setError('Failed to load products. Please try again later.');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const filteredProducts = useMemo(() => {
        let filtered = selectedCategory === 'all'
            ? products
            : products.filter(product => 
                product.category === selectedCategory || 
                product.category?.id === selectedCategory
            );

        if (searchQuery.trim()) {
            const searchLower = searchQuery.toLowerCase();
            filtered = filtered.filter(product => 
                product.name?.toLowerCase().includes(searchLower) ||
                product.description?.toLowerCase().includes(searchLower) ||
                (typeof product.category === 'string' && product.category.toLowerCase().includes(searchLower)) ||
                product.category?.name?.toLowerCase().includes(searchLower)
            );
        }

        return filtered;
    }, [selectedCategory, searchQuery, products]);

    const convertPrice = (price) => {
        const convertedPrice = (price || 0) * currentCurrency.rate;
        return `${currentCurrency.symbol}${convertedPrice.toFixed(2)}`;
    };

    if (loading) {
        return (
            <div className="store-page">
                <div className="store-loading">
                    <p>Loading products...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="store-page">
                <div className="store-error">
                    <p>{error}</p>
                    <button onClick={() => window.location.reload()}>Try Again</button>
                </div>
            </div>
        );
    }

    return (
        <div className="store-page">
            <div className="store-layout">
                <aside className="store-sidebar">
                    <SearchBar 
                        searchQuery={searchQuery}
                        onSearchChange={setSearchQuery}
                    />
                    <ProductFilter 
                        categories={categories}
                        selected={selectedCategory}
                        onSelect={setSelectedCategory}
                    />
                    <CurrencyConverter 
                        onCurrencyChange={setCurrentCurrency}
                    />
                </aside>

                <main className="store-main">
                    <ProductGrid 
                        products={filteredProducts}
                        onAddToCart={addToCart}
                        convertPrice={convertPrice}
                    />
                    {filteredProducts.length === 0 && (
                        <div className="no-results">
                            <p>No products found matching your search criteria.</p>
                        </div>
                    )}
                </main>
            </div>

        </div>
    );
};

export default StorePage;